import React from 'react';
import ShopLayout from '../../components/shop/ShopLayout';
import { Award, Users, Target, Heart, CheckCircle, MapPin } from 'lucide-react';

function ShopAbout() {
  const stats = [
    { number: '1L+', label: 'Happy Customers' },
    { number: '50K+', label: 'Devices Sold' },
    { number: '20+', label: 'Cities' },
    { number: '50+', label: 'Team Members' },
  ];

  const values = [
    { icon: Award, title: 'Quality First', desc: 'Every device goes through 34+ quality checks' },
    { icon: Users, title: 'Customer Centric', desc: 'We put our customers at the heart of everything' },
    { icon: Target, title: 'Transparency', desc: 'Clear grading system with honest descriptions' },
    { icon: Heart, title: 'Sustainability', desc: 'Promoting circular economy through refurbishment' },
  ];

  const milestones = [
    { year: '2018', event: 'ZOBOX founded with a vision to make quality tech affordable' },
    { year: '2019', event: 'Launched first Zomart retail store in Delhi' },
    { year: '2020', event: 'Expanded to 5 cities with online platform' },
    { year: '2021', event: 'Launched ZOBIZ B2R platform for resellers' },
    { year: '2022', event: 'Crossed 50,000 devices sold milestone' },
    { year: '2023', event: 'Expanded franchise network with Zomart Plus & Pro' },
    { year: '2024', event: 'Reached 1 Lakh+ happy customers' },
  ];

  return (
    <ShopLayout>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">About ZOBOX</h1>
            <p className="text-xl text-white/80">
              Pioneering India's refurbished tech revolution with quality, trust, and affordability.
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => (
              <div key={index} className="text-center p-6 bg-gray-50 rounded-xl">
                <p className="text-4xl font-bold text-primary mb-2">{stat.number}</p>
                <p className="text-gray-600">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Story */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Story</h2>
            <p className="text-gray-600 mb-4">
              ZOBOX was born from a simple observation: millions of perfectly functional smartphones and laptops were being discarded, while millions of Indians couldn't afford new devices.
            </p>
            <p className="text-gray-600 mb-4">
              Founded in 2018, we set out to bridge this gap by creating a trusted marketplace for refurbished technology. Our mission is to make quality tech accessible to every Indian while promoting sustainability.
            </p>
            <p className="text-gray-600">
              Today, ZOBOX has grown into India's most trusted refurbished tech platform, with a network of retail stores, a robust online presence, and the ZOBIZ app serving thousands of resellers.
            </p>
          </div>
        </div>
      </section>

      {/* Our Values */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-10">Our Values</h2>
          <div className="grid md:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="text-center p-6">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <value.icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-sm text-gray-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-10">Our Journey</h2>
          <div className="max-w-3xl mx-auto">
            {milestones.map((milestone, index) => (
              <div key={index} className="flex gap-4 mb-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center font-bold">
                    {milestone.year}
                  </div>
                </div>
                <div className="flex-1 pt-4">
                  <p className="text-gray-700">{milestone.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Join the ZOBOX Family</h2>
          <p className="text-white/80 mb-6">Experience quality refurbished tech at unbeatable prices</p>
          <a
            href="/shop/buy-mobile"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white text-primary rounded-full font-semibold hover:bg-gray-100 transition"
          >
            Start Shopping
          </a>
        </div>
      </section>
    </ShopLayout>
  );
}

export default ShopAbout;
